/* index.js */

"use strict";
const Registrations = require("./src/Registrations");
const Steve = require("@gluenetworks/steve_core").getInstance();
const SettingsSectionMgr = require("./src/app/SettingsSectionComponent");

Steve.di.registry.register(Registrations.SETTINGS_SECTION, SettingsSectionMgr);

let ManageMyUser = require("./src/seededcomponents/settingsscreens/user/ManageMyUser/ManageMyUserComponent");
Steve.di.registry.register(Registrations.MANAGE_MY_USER_SCREEN, ManageMyUser);
// let ManageUsers = require("./src/seededcomponents/settingsscreens/user/ManageUsers/ManageUsersComponent");
// Steve.di.registry.register(Registrations.MANAGE_USERS_SCREEN, ManageUsers);
let ManageCustFields = require("./src/seededcomponents/settingsscreens/org/CustomFields/CustomFieldsComponent");
Steve.di.registry.register(Registrations.MANAGE_CUSTOM_FIELDS_SCREEN, ManageCustFields);
let OSManagement = require("./src/seededcomponents/settingsscreens/org/OSManagement/OSManagementComponent");
Steve.di.registry.register(Registrations.OS_MANAGEMENT_SCREEN, OSManagement);
let ZoneManagement = require("./src/seededcomponents/settingsscreens/org/Zones/ZoneComponent");
Steve.di.registry.register(Registrations.MANAGE_ZONES_SCREEN, ZoneManagement);
let ManageRet = require("./src/seededcomponents/settingsscreens/org/DataRetention/DataRetentionComponent");
Steve.di.registry.register(Registrations.MANAGE_DATA_RET_SCREEN, ManageRet);
let ManageInt = require("./src/seededcomponents/settingsscreens/org/Integrations/IntegrationsComponent");
Steve.di.registry.register(Registrations.MANAGE_INTEGRATIONS, ManageInt);
let ManageOrgs = require("./src/seededcomponents/settingsscreens/org/ManageOrganizations/ManageOrgsComponent");
Steve.di.registry.register(Registrations.MANAGE_ORGS_SCREEN, ManageOrgs);
let ManageRoles = require("./src/seededcomponents/settingsscreens/org/ManageRoles/ManageRolesComponent");
Steve.di.registry.register(Registrations.MANAGE_ROLES_SCREEN, ManageRoles);
let Licensing = require("./src/seededcomponents/settingsscreens/org/Licensing/LicensingComponent");
Steve.di.registry.register(Registrations.MANAGE_LICENSES_SCREEN, Licensing);
let ManageEvents = require("./src/seededcomponents/settingsscreens/org/Events/EventsComponent");
Steve.di.registry.register(Registrations.MANAGE_EVENTS_SCREEN, ManageEvents);

let ManageOutboundSyslog = require("./src/seededcomponents/settingsscreens/org/OutboundSyslog/OutboundSyslogComponent");
Steve.di.registry.register(Registrations.MANAGE_OUTBOUND_SYSLOG_SCREEN, ManageOutboundSyslog);

let Dashboards = require("./src/seededcomponents/settingsscreens/org/ManageDashboards/ManageDashboardsComponent");
Steve.di.registry.register(Registrations.MANAGE_DASHBOARDS_SCREEN, Dashboards);

let Banner = require("./src/seededcomponents/settingsscreens/global/Banner/SystemBannerComponent");
Steve.di.registry.register(Registrations.SYSTEM_BANNER_SCREEN, Banner);

let Configuration = require("./src/seededcomponents/settingsscreens/global/Configuration/SystemConfigurationComponent");
Steve.di.registry.register(Registrations.SYSTEM_CONFIGURATION_SCREEN, Configuration);

let ProductInfo = require("./src/seededcomponents/settingsscreens/global/ProductInformation/ProductInfoComponent");
Steve.di.registry.register(Registrations.PRODUCT_INFO_SCREEN, ProductInfo);

let SingleSignOn = require("./src/seededcomponents/settingsscreens/global/SingleSignOn/SingleSignOnComponent");
Steve.di.registry.register(Registrations.SINGLE_SIGN_ON_SCREEN, SingleSignOn);

let Vaults = require("./src/seededcomponents/settingsscreens/org/Vaults/VaultsComponent");
Steve.di.registry.register(Registrations.VAULTS_SCREEN, Vaults);

let CaptureScreen = require("./src/seededcomponents/settingsscreens/org/Capture/CaptureComponent");
Steve.di.registry.register(Registrations.CAPTURE_SCREEN, CaptureScreen);

let CmdbViewScreen = require("./src/seededcomponents/settingsscreens/org/CMDB/CmdbViewComponent");
Steve.di.registry.register(Registrations.CMDB_SCREEN, CmdbViewScreen);

let ManageConnections = require("./src/seededcomponents/settingsscreens/org/ManageConnections/ManageConnectionsComponent");
Steve.di.registry.register(Registrations.MANAGE_CONNECTIONS_SCREEN, ManageConnections);
